"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Svg_1 = __importDefault(require("../Svg"));

var Stripe = function Stripe() {
  var st1 = {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    fill: '#0046D1'
  };
  return react_1.default.createElement(Svg_1.default, {
    width: '40px',
    height: '16px',
    viewBox: '0 0 40 16'
  }, react_1.default.createElement("g", {
    id: "Rectangle_2342"
  }, react_1.default.createElement("rect", {
    x: "1077.8",
    y: "-111",
    className: "st0",
    style: {
      fill: '#19232D'
    },
    width: "117",
    height: "230"
  }), react_1.default.createElement("rect", {
    x: "1078.3",
    y: "-110.5",
    className: "st0",
    style: {
      fill: '#19232D'
    },
    width: "116",
    height: "229"
  })), react_1.default.createElement("g", null, react_1.default.createElement("path", {
    id: "Path_739",
    className: "st1",
    style: st1,
    d: "M38.4,8.3c0-2.7-1.3-4.9-3.8-4.9s-4.1,2.1-4.1,4.9c0,3.2,1.8,4.8,4.4,4.8c1,0,2.1-0.2,3-0.7\n\t\tv-2.2c-0.8,0.4-1.7,0.6-2.6,0.6c-1.1,0-2-0.4-2.1-1.6h5.1C38.4,9.1,38.4,8.5,38.4,8.3z M33.1,7.3c0-1.2,0.7-1.7,1.4-1.7\n\t\tc0.6,0,1.4,0.5,1.4,1.7H33.1z"
  }), react_1.default.createElement("path", {
    id: "Path_740",
    className: "st1",
    style: st1,
    d: "M26.4,3.4c-0.8,0-1.5,0.3-2.1,0.8l-0.1-0.6h-2.3V16l2.7-0.5v-3c0.5,0.4,1.2,0.7,1.9,0.7\n\t\tc1.9,0,3.7-1.6,3.7-4.9C30,5.1,28.3,3.4,26.4,3.4z M25.7,10.7c-0.5,0-0.9-0.2-1.3-0.5v-4c0.3-0.4,0.8-0.6,1.3-0.5\n\t\tc1,0,1.6,1.1,1.6,2.5C27.4,9.6,26.7,10.7,25.7,10.7z"
  }), react_1.default.createElement("path", {
    id: "Path_741",
    className: "st1",
    style: st1,
    d: "M18.1,2.7l2.7-0.5V0l-2.7,0.5V2.7z"
  }), react_1.default.createElement("rect", {
    id: "Rectangle_1682",
    x: "18.1",
    y: "3.6",
    className: "st2",
    style: {
      fill: '#0046D1'
    },
    width: "2.7",
    height: "9.3"
  }), react_1.default.createElement("path", {
    id: "Path_742",
    className: "st1",
    style: st1,
    d: "M15.3,4.3l-0.2-0.8h-2.3v9.3h2.7V6.6c0.5-0.6,1.3-0.8,2-0.5V3.6C16.6,3.2,15.7,3.6,15.3,4.3z"
  }), react_1.default.createElement("path", {
    id: "Path_743",
    className: "st1",
    style: st1,
    d: "M9.9,1.2L7.3,1.8v8.6c0,1.5,1.1,2.7,2.6,2.7c0.1,0,0.1,0,0.2,0c0.6,0,1.3-0.1,1.9-0.4v-2.2\n\t\tc-0.3,0.1-2,0.6-2-1V5.8h2V3.5h-2L9.9,1.2z"
  }), react_1.default.createElement("path", {
    id: "Path_744",
    className: "st1",
    style: st1,
    d: "M2.7,6.3c0-0.4,0.4-0.6,0.9-0.6c0.9,0,1.8,0.2,2.7,0.7V3.9C5.4,3.5,4.5,3.4,3.6,3.4\n\t\tC1.5,3.4,0,4.5,0,6.4c0,3,4.1,2.5,4.1,3.7c0,0.5-0.4,0.6-1,0.6c-1-0.1-2-0.4-2.9-0.9v2.6c0.9,0.4,1.9,0.6,2.9,0.6\n\t\tc2.2,0,3.7-1.1,3.7-3C6.8,6.9,2.7,7.5,2.7,6.3z"
  })));
};

exports.default = Stripe;
Stripe.displayName = 'Stripe';